module.exports = __webpack_public_path__ + "static/logo_equipe-79a7e89b2c42a9f088ea0fdc1d2be66e.png";